import { render, staticRenderFns } from "./ItensMenuConfiguracao.vue?vue&type=template&id=05beb18e&scoped=true&"
import script from "./ItensMenuConfiguracao.vue?vue&type=script&lang=js&"
export * from "./ItensMenuConfiguracao.vue?vue&type=script&lang=js&"
import style0 from "./ItensMenuConfiguracao.vue?vue&type=style&index=0&id=05beb18e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05beb18e",
  null
  
)

export default component.exports